// Header mega-menu hover js
let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
        item.querySelector("ul").addEventListener("mouseleave", () => {
            item.removeAttribute("open");
        });
        item.addEventListener("mouseleave", () => {
            item.removeAttribute("open");
        });
    });
  });


  // --------------------- popup js -------
  
  $(document).ready(function() {
    // Check if the pop-up has already been opened in the current session
    if (!sessionStorage.getItem('popupOpened')) {
        $('.popup-with-zoom-anim').magnificPopup({
            type: 'inline',
            fixedContentPos: false,
            fixedBgPos: true,
            overflowY: 'auto',
            closeBtnInside: true,
            preloader: false,
            midClick: true,
            removalDelay: 300,
            mainClass: 'my-mfp-zoom-in',
            callbacks: {
                open: function() {
                    $('body').addClass('popup-open'); // Add class when popup opens
                },
                close: function() {
                    $('body').removeClass('popup-open'); // Remove class when popup closes
                }
            }
        }).magnificPopup('open'); // Open the pop-up

        // Set a flag in sessionStorage to prevent it from opening again during the session
        sessionStorage.setItem('popupOpened', 'true');
    }
});

  $('.image-slider_wrapper .image-slider__media-item').slick({
    dots: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
  });

  document.addEventListener('DOMContentLoaded', function() {

    // ---------------------Mobile Account ICon click-------
    var Accounticon = document.querySelector(".account-links-mobile");
  
    if (Accounticon) {
      Accounticon.addEventListener('click', function() {
        this.classList.toggle('active');
      });
    }

    // ---------------------LayoutChange click-------
    var layout = document.querySelectorAll(".collection__layout-button");
    
    if (layout.length > 0) {
      layout.forEach(function(LayoutChange) {
        LayoutChange.addEventListener('click', function(event) {
          event.preventDefault();
                
          // Select all layout buttons and remove the "active" class from each
          var removeClass = document.querySelectorAll(".collection__layout-button");
          removeClass.forEach(function(button) {
            button.classList.remove("active");
          });
    
          // Add the "active" class to the clicked button
          var layoutData = this.getAttribute('data-title');
          this.classList.add("active");
    
          if (layoutData) {
            // Get the element with ID 'product-grid'
            var element = document.getElementById("product-grid");
    
            // Set the 'data-layout' attribute to the value of layoutData
            element.setAttribute("data-layout", layoutData);
          }
        });
      });
    }  

    // ---------------------product click-------
    const tabs = document.querySelectorAll('.tab-title');
    const contents = document.querySelectorAll('.tab-content');
    
    tabs.forEach((tab) => {
      tab.addEventListener('click', function () {
        tabs.forEach((item) => item.classList.remove('active'));
        contents.forEach((item) => item.classList.remove('active'));
    
        this.classList.add('active');
        document.querySelector(this.dataset.tabContent).classList.add('active');
      });
    });
    
    if (tabs.length > 0) {
      tabs[0].classList.add('active');
      contents[0].classList.add('active');
    }



  // //custom product grouping
  //  var url = 'https://shelving-net.myshopify.com/collections/all';
    
  //   var productOptions = document.querySelectorAll(".variant-options-wrapper .option-block");
  //   if(productOptions.length){
  //     productOptions.forEach(function(productOption){
  //       var activeOptions = productOption.querySelectorAll(".option-value.active");
  //       if(activeOptions){
  //         activeOptions.forEach(function(activeOption){
  //           var value = activeOption.getAttribute("data-value");
  //           var namespace = activeOption.getAttribute("data-namespace");
  //           var key = activeOption.getAttribute("data-key");

  //           if(!(url.includes(key))){
  //               var param = namespace + "." + key + "=" + value;
  //               if (url.includes('?')) {
  //                  url =  url + '&filter.p.m.' + param;
  //               } else {
  //                url = url + '?filter.p.m.' + param;
  //               }
  //           }
  //           console.log("URL",url);
  //         });
  //       }

        
  //       var options = productOption.querySelectorAll(".option-value");
  //       if(options.length){
       
  //         options.forEach(function(option){
  //           option.addEventListener('click', function () {
  //               var value = option.getAttribute("data-value");
  //               var namespace = option.getAttribute("data-namespace");
  //               var key = option.getAttribute("data-key");
              
  //               console.log("Value", value);
  //               console.log("namespace", namespace);
  //               console.log("key", key);
              
  //               // Construct the parameter key for the URL
  //               let paramKey = `filter.p.m.${namespace}.${key}`;
  //               let paramValue = `${paramKey}=${value}`;
              
  //               // Check if the key exists in the URL
  //               if (url.includes(paramKey)) {
  //                 // Replace the value for the key if it exists
  //                 const paramRegex = new RegExp(`(${paramKey}=)[^&]*`); // Match key=value
  //                 url = url.replace(paramRegex, `$1${value}`);
  //               } else {
  //                 // Append the key and value if it doesn't exist
  //                 if (url.includes('?')) {
  //                   url = url + '&' + paramValue;
  //                 } else {
  //                   url = url + '?' + paramValue;
  //                 }
  //               }
              
  //               console.log("Updated URL", url);
              
  //               async function fetchFilteredProducts(url) {
  //                 try {
  //                   // Fetch filtered collection page
  //                   const response = await fetch(url);
  //                   if (!response.ok) throw new Error('Failed to fetch the filtered URL');
              
  //                   // Parse HTML response
  //                   const htmlText = await response.text();
  //                   const parser = new DOMParser();
  //                   const doc = parser.parseFromString(htmlText, 'text/html');

  //                   console.log("Document",doc);
  //                   var productGroup = doc.querySelector(".product-grid-wrapper .product-grid");
  //                   if(productGroup){
  //                     var productUrl = productGroup.querySelector("li a").href;
  //                     window.location.href = productUrl;
  //                     console.log("productUrl", productUrl);                      
  //                   }else{
  //                    var productFormButton = document.querySelector(".product-form__buttons");
  //                    var button = productFormButton.querySelector("button").setAttribute("disabled",'disabled');
  //                     var spanText = productFormButton.querySelector("span").textContent = 'Sold Out';
  //                   }
                   
  //                 } catch (error) {
  //                   console.error('Error fetching filtered products:', error);
  //                   return [];
  //                 }
  //               }
  //               fetchFilteredProducts(url);
  //             });

  //         });
  //       }
  //     });

  //   }


   var currentCollection = document.querySelector(".variant-options-wrapper")?.getAttribute("colletion-title");
    
    var url = 'https://shelving-net.myshopify.com/collections/' + currentCollection;
      var productOptions = document.querySelectorAll(".variant-options-wrapper .option-block");
      
      // Object to store the previous values for each option
      var previousValues = {};
      
      if (productOptions.length) {
        productOptions.forEach(function (productOption) {
          var activeOptions = productOption.querySelectorAll(".option-value.active");
          if (activeOptions) {
            activeOptions.forEach(function (activeOption) {
              var value = activeOption.getAttribute("data-value");
              var namespace = activeOption.getAttribute("data-namespace");
              var key = activeOption.getAttribute("data-key");
      
              if (!(url.includes(key))) {
                var param = namespace + "." + key + "=" + value;
                if (url.includes('?')) {
                  url = url + '&filter.p.m.' + param;
                } else {
                  url = url + '?filter.p.m.' + param;
                }
              }
      
              // Store the initial value as the previous value
              previousValues[`${namespace}.${key}`] = value;
      
              console.log("URL", url);
            });
          }
      
          var options = productOption.querySelectorAll(".option-value");
          if (options.length) {
            options.forEach(function (option) {
              option.addEventListener('click', function () {
                options.forEach(function (option) {
                  option.classList.remove("active");
                });
      
                option.classList.add("active");
                var value = option.getAttribute("data-value");
                var namespace = option.getAttribute("data-namespace");
                var key = option.getAttribute("data-key");
      
                console.log("Value", value);
                console.log("Namespace", namespace);
                console.log("Key", key);
      
                // Construct the parameter key for the URL
                let paramKey = `filter.p.m.${namespace}.${key}`;
                let paramValue = `${paramKey}=${value}`;
      
                // Store the previous value for the key
                if (!previousValues[paramKey]) {
                  previousValues[paramKey] = value;
                }
      
                // Check if the key exists in the URL
                if (url.includes(paramKey)) {
                  // Replace the value for the key if it exists
                  const paramRegex = new RegExp(`(${paramKey}=)[^&]*`); // Match key=value
                  url = url.replace(paramRegex, `$1${value}`);
                } else {
                  // Append the key and value if it doesn't exist
                  if (url.includes('?')) {
                    url = url + '&' + paramValue;
                  } else {
                    url = url + '?' + paramValue;
                  }
                }
      
                console.log("Updated URL", url);
      
                async function fetchFilteredProducts(url) {
                  try {
                    // Fetch filtered collection page
                    const response = await fetch(url);
                    if (!response.ok) throw new Error('Failed to fetch the filtered URL');
      
                    // Parse HTML response
                    const htmlText = await response.text();
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(htmlText, 'text/html');
      
                    console.log("Document", doc);
                    var productGroup = doc.querySelector(".product-grid-wrapper .product-grid");
                    if (productGroup) {
                      var productUrl = productGroup.querySelector("li a").href;
                      window.location.href = productUrl;
                      console.log("productUrl", productUrl);
                    } else {
                      // No product found: Disable button and revert URL
                      var productFormButton = document.querySelector(".product-form__buttons");
                      var button = productFormButton.querySelector("button");
                      button.setAttribute("disabled", 'disabled');
                      productFormButton.querySelector("span").textContent = 'Sold Out';
      
                      // Revert to the previous value
                      if (previousValues[paramKey]) {
                        const revertValue = previousValues[paramKey];
                        url = url.replace(new RegExp(`(${paramKey}=)[^&]*`), `$1${revertValue}`);
                        console.log("Reverted URL", url);
                      }
                    }
                  } catch (error) {
                    console.error('Error fetching filtered products:', error);
                    return [];
                  }
                }
      
                fetchFilteredProducts(url);
              });
            });
          }
        });
      }

    
  });


 
  




